import GUI from 'lil-gui'
import * as THREE from 'three'

export default class Land extends THREE.Object3D {
    constructor() {
        super()
        this.textureLoader = new THREE.TextureLoader();
        this._init();
    }

    _init() {
        this._createGround()
        this._createGraves()
    }

    _createGraves() {
        const graveColorTexture = this.textureLoader.load('./assets/textures/grave/lichen_rock_1k/lichen_rock_diff_1k.webp')
        const graveARMTexture = this.textureLoader.load('./assets/textures/grave/lichen_rock_1k/lichen_rock_arm_1k.webp')
        const graveNormalTexture = this.textureLoader.load('./assets/textures/grave/lichen_rock_1k/lichen_rock_nor_gl_1k.webp')
        
        graveColorTexture.colorSpace = THREE.SRGBColorSpace
        
        graveColorTexture.repeat.set(0.3, 0.4)
        graveARMTexture.repeat.set(0.3, 0.4)
        graveNormalTexture.repeat.set(0.3, 0.4)

        const graveGeometry = new THREE.BoxGeometry(0.6, 0.8, 0.2)
        const graveMaterial = new THREE.MeshStandardMaterial({
            map: graveColorTexture,
            aoMap: graveARMTexture,
            roughnessMap: graveARMTexture,
            metalnessMap: graveARMTexture,
            normalMap: graveNormalTexture
        })

        const graves = new THREE.Group()

        for (let i = 0; i < 30; i++) {
            const angle = Math.random() * Math.PI * 2
            const radius = 3 + Math.random() * 4
            const x = Math.sin(angle) * radius
            const z = Math.cos(angle) * radius

            const grave = new THREE.Mesh(graveGeometry, graveMaterial)
            grave.position.x = x
            grave.position.y = Math.random() * 0.5
            grave.position.z = z

            grave.rotation.x = (Math.random() - 0.5) * 0.4
            grave.rotation.y = (Math.random() - 0.5) * 0.5
            grave.rotation.z = (Math.random() - 0.5) * 0.4

            graves.add(grave)
        }

        graves.children.forEach((grave) => {
            grave.castShadow = true
            grave.receiveShadow = true
        })

        this.add(graves)
    }

    _createGround() {
        const groundAlphaTexture = this.textureLoader.load('./assets/textures/ground/alpha.webp')
        const groundColorTexture = this.textureLoader.load('./assets/textures/ground/rocky_terrain_1k/rocky_terrain_diff_1k.webp')
        const groundARMTexture = this.textureLoader.load('./assets/textures/ground/rocky_terrain_1k/rocky_terrain_arm_1k.webp')
        const groundNormalTexture = this.textureLoader.load('./assets/textures/ground/rocky_terrain_1k/rocky_terrain_nor_gl_1k.webp')
        const groundDisplacementTexture = this.textureLoader.load('./assets/textures/ground/rocky_terrain_1k/rocky_terrain_disp_1k.webp')
        
        groundColorTexture.colorSpace = THREE.SRGBColorSpace
        
        groundColorTexture.repeat.set(8, 8)
        groundARMTexture.repeat.set(8, 8)
        groundNormalTexture.repeat.set(8, 8)
        groundDisplacementTexture.repeat.set(8, 8)
        
        groundColorTexture.wrapS = THREE.RepeatWrapping
        groundARMTexture.wrapS = THREE.RepeatWrapping
        groundNormalTexture.wrapS = THREE.RepeatWrapping
        groundDisplacementTexture.wrapS = THREE.RepeatWrapping
        
        groundColorTexture.wrapT = THREE.RepeatWrapping
        groundARMTexture.wrapT = THREE.RepeatWrapping
        groundNormalTexture.wrapT = THREE.RepeatWrapping
        groundDisplacementTexture.wrapT = THREE.RepeatWrapping

        const ground = new THREE.Mesh(
            new THREE.PlaneGeometry(20, 20, 100, 100),
            new THREE.MeshStandardMaterial({
                alphaMap: groundAlphaTexture,
                transparent: true,
                map: groundColorTexture,
                aoMap: groundARMTexture,
                roughnessMap: groundARMTexture,
                metalnessMap: groundARMTexture,
                normalMap: groundNormalTexture,
                displacementMap: groundDisplacementTexture,
                displacementScale: 0.3,
                displacementBias: -0.2
            })
        )
        ground.rotation.x = - Math.PI * 0.5
        ground.castShadow = true
        ground.receiveShadow = true

        this.add(ground)

        if (import.meta.env.DEV) {
            const gui = new GUI()
        
            gui.add(ground.material, 'displacementScale').min(0).max(1).step(0.001).name('groundDisplacementScale')
            gui.add(ground.material, 'displacementBias').min(0).max(1).step(0.001).name('groundDisplacementBias')
        }
    }
}